//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/PlaneList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"AddOffset",0,"Expression",0],[0,"Associative",1,0],[0,"CloseGaps",1,0],[0,"CoordSystem",1,"CoordinateSystem",0],[0,"DistanceTolerance",1,0],[1,"ObjectToReplace",0,"SelectDisplayableObjectList",0],[1,"PlanesList",0,"PlaneList",0],[0,"ReplaceWith",1,0],[1,"SplitOffset",0,"Expression",0]],[[[],"DoReplace",{},0,0]],[]];
SPLM.SIM.SinumerikCaSimplifyBodiesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.SinumerikCaSimplifyBodiesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.SinumerikCaSimplifyBodiesBuilder.ObjectToReplaceWithTypes = Object.freeze({
    "Nothing" : "Nothing", "ConvexHull" : "ConvexHull", "BoundingSphere" : "BoundingSphere", "BoundingBlock" : "BoundingBlock", "BoundingCylinder" : "BoundingCylinder", "InscribedCylinder" : "InscribedCylinder"});

SPLM.SIM.SinumerikCaSimplifyBodiesBuilder.CloseGapTypes = Object.freeze({
    "Sharp" : "Sharp", "Beveled" : "Beveled", "NoOffset" : "NoOffset"});

export default SPLM;